import {
  type Dispatch,
  type FC,
  type ReactNode,
  type SetStateAction,
} from 'react'
import { withAuthGuard } from '@/hocs/with-auth-guard'
import { useSettings } from '@/hooks/use-settings'
import { useChangelogReleases } from '@/components/WhatsNewModal'
import { CommandBarProvider } from '@/components/CommandBar'
import { ProductTourProvider } from '@/components/ProductTour'
import { useSections } from './config'
import { VerticalLayout } from './vertical-layout'

interface LayoutProps {
  children?: ReactNode
  isFullscreen?: boolean
  sideNavExpanded?: boolean
  setSideNavExpanded?: Dispatch<SetStateAction<boolean>>
}

export const Layout: FC<LayoutProps> = withAuthGuard((props) => {
  const settings = useSettings()
  const sections = useSections()
  const changelog = useChangelogReleases()

  return (
    <CommandBarProvider>
      <ProductTourProvider holdAutoStart={changelog.isLoading}>
        <VerticalLayout
          {...props}
          sections={sections}
          changelog={changelog}
          navColor={settings.navColor}
          isFullscreen={props.isFullscreen}
          sideNavExpanded={props.sideNavExpanded ?? true}
          setSideNavExpanded={props.setSideNavExpanded}
        />
      </ProductTourProvider>
    </CommandBarProvider>
  )
}, null)
